import {ErrorMessage, Field, withFormik} from "formik";
import * as Yup from 'yup';
import React from "react";
import {AuthenticatedTemplate, UnauthenticatedTemplate} from '@azure/msal-react';


class AddEmployeeForm extends React.PureComponent {
    constructor(props) {
        super(props);


    }

    render() {
        const {
            submitCount,
            isValid,
            touched,
            handleChange,
            handleBlur,
            values,
            errors,
            handleSubmit,
            setFieldValue,
            setValues
        } = this.props;

        return submitCount === 1 ? (
            <div>
                <AuthenticatedTemplate>
                    <div className="page-title-sh26">
                        <h3>Successfully added employee to the database!</h3>
                    </div>

                    <div className="page-break"></div>
                    <div className="list-section">
                        <a className="btn-secondary btn" href="/management/employees"><span> ← Employee Overview </span>
                        </a>
                    </div>
                    <div className="page-break"></div>
                </AuthenticatedTemplate>
            </div>
        ) : (
            <div>
                <UnauthenticatedTemplate>
                    <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
                </UnauthenticatedTemplate>

                <AuthenticatedTemplate>

                    <a className="btn-secondary btn float-start m-0 pb-0 pt-0" href="/management/employees"><span> ← Employee Overview </span>
                    </a>

                    <div className="page-title-sh26">
                        <h1 className="mb-2">Add Employee Form</h1>
                    </div>
                    <hr/>
                    <div className="list-section">
                        <form onSubmit={handleSubmit}>
                            <br/>
                            <h3 className="mt-2 text-center">Employee details</h3>
                            <br/>
                            <div className="row">
                                <div className="col-12 mb-2">
                                    <label htmlFor="name">Name:</label>
                                    <Field name="name" className="form-control"/>
                                    <ErrorMessage name="name" component="div" className="text-danger"/>
                                </div>

                                <div className="col-12 col-sm-6">
                                    <label htmlFor="email">Email:</label>
                                    <Field name="email" type="email" className="form-control"/>
                                    <ErrorMessage name="email" component="div" className="text-danger"/>
                                </div>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="phone">Phone:</label>
                                    <Field name="phone" type="tel" className="form-control"/>
                                    <ErrorMessage name="phone" component="div" className="text-danger"/>
                                </div>
                                <div className="page-break"></div>
                                <br/>
                                <div className="col-12 mt-2 mb-4 checklist">
                                    <br/>
                                    <label htmlFor="roles">Roles :</label>
                                    <br/>
                                    <label>
                                        <Field type="checkbox" name="roles" value="Management Staff"/>
                                        Management Staff
                                    </label>
                                    <br/>
                                    <label>
                                        <Field type="checkbox" name="roles" value="Admin Staff"/>
                                        Administration Staff
                                    </label>
                                    <br/>
                                    <label>
                                        <Field type="checkbox" name="roles" value="Design Staff"/>
                                        Design Staff
                                    </label>
                                    <br/>
                                    <label>
                                        <Field type="checkbox" name="roles" value="Printing Staff"/>
                                        Printing Staff
                                    </label>
                                    <br/>
                                    <label>
                                        <Field type="checkbox" name="roles" value="Installation Staff"/>
                                        Installation Staff
                                    </label>
                                    <br/><br/>
                                </div>
                            </div>

                            <div className="row mt-3 text-center">
                                <div>
                                    <button className="btn btn-primary" type="submit" disabled={!isValid}>Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="page-break"></div>
                </AuthenticatedTemplate>
            </div>

        )
    }
}

export default withFormik({
    enableReinitialize: true,
    mapPropsToValues: () => ({
        name: '',
        email: '',
        phone: '',
        roles: '',
    }),

    validationSchema: Yup.object().shape({
        name: Yup.string().required("Name is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        phone: Yup.string().required("Phone number is required").matches(/^[0-9]+$/, "Must be only digits")
            .min(8, 'Must be between 8 and 11 digits')
            .max(11, 'Must be between 8 and 11 digits'),
    }),
    validateOnMount: true,
    handleSubmit: async (values) => {
        
        //actions.addEmployee(values);
    }
})(AddEmployeeForm)
